import { registerEnum } from '@adornis/baseql/metadata/register.js';

export enum Fachschaft {
  'INFORMATIK' = 'INFORMATIK',
  'IST' = 'IST',
  'WIWI' = 'WIWI',
}

registerEnum({ enum: Fachschaft, name: 'Fachschaft' });
